export default "__VITE_ASSET__CDkDirix__"